export default "__VITE_ASSET__e14f65d5__"